import { Dictionary, groupBy } from 'lodash';
import { TourStore as TourModel } from '../../stores/tour';

interface Entry {
    name: string;
    originalName: string;
    toursCount: number;
}

export function uniteDupsEntries(groups: Dictionary<TourModel[]>): Dictionary<TourModel[]> {
    let arr = Object.keys(groups).map(key => ({
        name: key.split(' ').sort().join(' '),
        originalName: key,
        toursCount: groups[key].length
    } as Entry)
    );
    let grouped = groupBy(arr, e => e.name);

    Object.keys(grouped).forEach(key => {
        if (grouped[key].length > 1) {
            let sorted = grouped[key].sort((a, b) => a.toursCount > b.toursCount ? -1 : 1);
            sorted.forEach((el, i) => {
                if (i > 0) {
                    groups[sorted[0].originalName].push(...groups[el.originalName]);
                    delete groups[el.originalName];
                }
            });
        }
    });

    return groups;
}
